import { FormattedMessage } from 'react-intl';
import { useClientConfig } from 'src/hooks/useClientConfig';
import { useIsBubbleWidget } from 'src/hooks/useIsBubbleWidget';
import { useIsEmbedded } from 'src/hooks/useIsEmbedded';
import logo from 'src/static/vectors/logo-block.svg';
import WidgetThumb from '../Widget/WidgetThumb/WidgetThumb';

import '../../components/ErrorBoundary/ErrorBoundary.sass';

const ErrorShareChat = () => {
	const isBubbleWidget = useIsBubbleWidget();
	const isEmbedded = useIsEmbedded();
	const hideHostChrome = isBubbleWidget || isEmbedded;
	const client = useClientConfig();
	return (
		<div className="error page">
			<header id="masthead">{hideHostChrome ? <WidgetThumb /> : <img src={client?.image?.toString() ?? logo} alt="logo" />}</header>
			<div className="error-illustration" />
			<section>
				<h1>
					<FormattedMessage id="error.title" />
				</h1>
				<p>
					<FormattedMessage id="error.share.not-found" />
				</p>
			</section>
		</div>
	);
};

export default ErrorShareChat;
